export default "__VITE_ASSET__RwsB8R_p__"